<template>
  <b-row class="mt-5">
    <b-col cols="12">
      <h4>Historial notificaciones asignadas al usuario</h4>
      <el-table class="table-responsive table"
                header-row-class-name="thead-light"
                :data="tableDataUser">
        <el-table-column label="DESTINO"
                         min-width="170px"
                         prop="notificationsId.type">
        </el-table-column>
        <el-table-column label="TITULO"
                         prop="notificationsId.title"
                         min-width="300px">
        </el-table-column>
        <el-table-column label="MENSAJE"
                         prop="notificationsId.message"
                         min-width="300px">
        </el-table-column>
        <el-table-column label="Estado"
                         prop="status"
                         min-width="300px">
          <template v-slot="{row}">
            {{row.status|status}}
          </template>
        </el-table-column>
        <el-table-column label="Opciones" min-width="100px" fixed="right">
          <template v-slot="{row}">
            <button class="btn btn-sm btn-outline-primary" title="Ver preview" @click="preview(row._id)">
              <i class="ni ni-zoom-split-in"></i>
            </button>
          </template>
        </el-table-column>
      </el-table>
    </b-col>
  </b-row>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";

export default {
  name: "Notifications",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    tableDataUser: [],
    search: ''
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      get('notifications/find-all-user', this.$route.params.id, true).then(({data}) => {
        this.tableDataUser = data
      })
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
    preview(id, type = 'client') {
      let model = null
      model = this.tableDataUser.find(x => x._id === id).notificationsId
      this.$swal({
        title: model.title,
        html: model.message,
        icon: model.icon,
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      })
    }
  }
}
</script>

<style scoped>

</style>
